import React, { Component } from "react"
import {connect} from 'react-redux'
import i18n from 'lib/i18n'
import styles from './../documents.scss'
//import {UPLOADER_STATE_NEW_POLICY, UPLOADER_STATE_POLICY_FILE, DS_MODULE_CLIENT_CONTRACT} from 'state/constants'

// init translations
const _ = i18n('dswizard')

@connect(
    (state) => {
        return {}
    }
)

// TODO hardcoded values to be provided by file selector
export default class OracleDocumentButton extends Component {
    static propTypes = {
        onSelectDocuments: React.PropTypes.func.isRequired
    }

    render () {
        const {onSelectDocuments}  = this.props

        return (
            <div className={styles.documentsModalButtons}>
                 <button type="button"
                        className={styles.greenButton}
                        onClick={() => {
                            return onSelectDocuments({
                                id: "",
                                type: ""
                            })
                        }}>
                        <div className={styles.iconContainer}>
                            <img src={require("resources/icn-plus.svg")}/>
                        </div>
                        {_("selectDocument")}
                </button>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/DSDocuments/SelectOracleDocument/OracleDocumentButton.jsx